import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { doc, getDoc, collection } from 'firebase/firestore';
import { db } from '../../firebaseconfig';
import { useAuth } from '../../contexts/AuthContext';

const StaffRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isStaff, setIsStaff] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    const checkStaffStatus = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        const staffDoc = await getDoc(doc(collection(db, 'users'), currentUser.uid));
        
        if (staffDoc.exists() && staffDoc.data().active) {
          setIsStaff(true);
        }
      } catch (error) {
        console.error('Error checking staff status:', error);
      } finally {
        setLoading(false);
      }
    };

    checkStaffStatus();
  }, [currentUser]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  /*if (!currentUser) {
    return <Navigate to="/login" />;
  }*/

  if (!isStaff) {
    console.log(isStaff);
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default StaffRoute; 